import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import { SubCompany } from "@/core/services/api/interfaces/common/SubCompany";

@Module
export default class AffiliateCompaniesModule extends VuexModule {
  pagination = new PaginationResponse<SubCompany>();
  loading = false;

  get affiliateCompanies(): SubCompany[] {
    return this.pagination.data;
  }

  get affiliateCompaniesLoading(): boolean {
    return this.loading;
  }

  get affiliateCompaniesPagination(): PaginationResponse<SubCompany> {
    return this.pagination;
  }

  get affiliateCompaniesTotal(): number {
    return this.pagination.total;
  }

  get affiliateCompaniesRequired(): boolean {
    return !this.pagination.total && !this.loading;
  }

  get affiliateCompaniesCurrentPage(): number {
    return this.pagination.current_page;
  }

  get affiliateCompaniesPerPage(): number {
    return this.pagination.per_page;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_AFFILIATE_COMPANIES_LOAD](params) {
    this.context.commit(
      Mutations.MANAGER_AFFILIATE_COMPANIES_SET_LOADING,
      true
    );
    ApiService.manager.affiliates
      .list({
        params: params,
      } as AxiosRequestConfig)
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(
          Mutations.MANAGER_AFFILIATE_COMPANIES_SET,
          response
        );
      })
      .catch(console.error)
      .finally(() => {
        this.context.commit(
          Mutations.MANAGER_AFFILIATE_COMPANIES_SET_LOADING,
          false
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_AFFILIATE_COMPANIES_LOAD
        );
      });
  }

  @Mutation
  [Mutations.MANAGER_AFFILIATE_COMPANIES_RESET]() {
    this.pagination = new PaginationResponse<SubCompany>();
  }

  @Mutation
  [Mutations.MANAGER_AFFILIATE_COMPANIES_SET](
    pagination: PaginationResponse<SubCompany>
  ) {
    this.pagination = pagination;
  }

  @Mutation
  [Mutations.MANAGER_AFFILIATE_COMPANIES_SET_LOADING](loading: boolean) {
    this.loading = loading;
  }
}
